export const SITE_URL = 'https://www.nishadconnect.com';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/favicon.png`;

// ─── Dedicated OG images (Firebase-hosted product photos) ───
// TODO: Replace with product-specific OG images (wires product photo for wires, fan photo for fans)
export const WIRE_OG_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/nishad-web-a022a.appspot.com/o/nishad-web-assets%2Fhewlogo.jpg?alt=media&token=66dbf8fe-fd57-473a-98e0-995176a85ffd';
export const FAN_OG_IMAGE = 'https://firebasestorage.googleapis.com/v0/b/nishad-web-a022a.appspot.com/o/nishad-web-assets%2Fhewlogo.jpg?alt=media&token=66dbf8fe-fd57-473a-98e0-995176a85ffd';

export const NISHAD_ADDRESS = {
    "@type": "PostalAddress",
    "streetAddress": "57, Jai Complex, Near Road No. 2",
    "addressLocality": "Alwar",
    "addressRegion": "Rajasthan",
    "postalCode": "301001",
    "addressCountry": "IN"
};

export const NISHAD_SAME_AS = [
    'https://www.facebook.com/profile.php?id=61586917624557',
    'https://www.linkedin.com/in/nishadconnect/'
];

export const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "NISHAD Cables",
    "alternateName": "NISHAD",
    "url": SITE_URL,
    "logo": DEFAULT_OG_IMAGE,
    "address": NISHAD_ADDRESS,
    "sameAs": NISHAD_SAME_AS,
    "knowsAbout": [
        { "@type": "Thing", "name": "Electrical cable", "sameAs": "https://www.wikidata.org/wiki/Q188447" },
        { "@type": "Thing", "name": "Copper", "sameAs": "https://www.wikidata.org/wiki/Q753" },
        { "@type": "Thing", "name": "Ceiling fan", "sameAs": "https://www.wikidata.org/wiki/Q1181944" },
        { "@type": "Thing", "name": "Christmas lights", "sameAs": "https://www.wikidata.org/wiki/Q1653073" },
        { "@type": "Thing", "name": "Bureau of Indian Standards", "sameAs": "https://www.wikidata.org/wiki/Q3522686" }
    ]
};

export const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "NISHAD",
    "url": SITE_URL,
    "inLanguage": "en-IN",
    "publisher": {
        "@type": "Organization",
        "name": "NISHAD Cables",
        "url": SITE_URL
    }
};

export const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "NISHAD Cables",
    "alternateName": "Nishad Wires & Fans",
    "image": DEFAULT_OG_IMAGE,
    "url": SITE_URL,
    "telephone": "+91-9414018888",
    "address": NISHAD_ADDRESS,
    "geo": {
        "@type": "GeoCoordinates",
        "latitude": 27.5530,
        "longitude": 76.6346
    },
    "areaServed": {
        "@type": "Country",
        "name": "India"
    },
    "priceRange": "₹₹",
    "openingHoursSpecification": {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "opens": "09:00",
        "closes": "18:00"
    },
    "sameAs": NISHAD_SAME_AS
};

export const getBreadcrumbSchema = (items) => ({
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": item.url
    }))
});
